var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { retry } from "@reduxjs/toolkit/query";
import axios from "axios";
import { formatError } from "./errorHelpers";
const axiosQuery = (baseConfig) => (endpointConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const result = yield axios(Object.assign(Object.assign(Object.assign({}, baseConfig), endpointConfig), { headers: Object.assign(Object.assign({}, baseConfig.headers), endpointConfig.headers) }));
        return { data: result.data };
    }
    catch (axiosError) {
        const err = axiosError;
        return {
            error: { status: (_a = err.response) === null || _a === void 0 ? void 0 : _a.status, data: formatError(err) },
        };
    }
});
/**
 * Transforms hive request config to match axios request config
 */
const transformConfig = (baseConfig) => {
    var _a;
    const prepareHeaders = baseConfig.prepareHeaders
        ? [
            (data, headers) => {
                var _a;
                if (headers) {
                    // eslint-disable-next-line no-param-reassign
                    Object.assign(headers, (_a = baseConfig.prepareHeaders) === null || _a === void 0 ? void 0 : _a.call(baseConfig, headers));
                }
                return data;
            },
        ]
        : [];
    return Object.assign(Object.assign({}, baseConfig), { transformRequest: [
            ...prepareHeaders,
            ...((_a = baseConfig.transformRequest) !== null && _a !== void 0 ? _a : []),
            ...axios.defaults.transformRequest,
        ] });
};
/**
 * Axios base query to use with RTK queries createAPI.
 * It incorporates retry with exponential back-off and
 * bail out on certain status codes.
 *
 * @default
 * numberOfRetries - 3
 * doNotRetryErrorCodes - [401, 403, 404]
 *
 * @author nikola
 * */
export const baseQuery = (baseConfig) => {
    var _a;
    return retry((endpointConfig, api, extraOptions) => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        const result = yield axiosQuery(transformConfig(baseConfig))(endpointConfig, api, extraOptions);
        // bail out of re-tries immediately if one of this statuses,
        // because we know successive re-retries would be redundant
        const doNotRetryErrorCodes = (_b = baseConfig.doNotRetryErrorCodes) !== null && _b !== void 0 ? _b : [
            401,
            403,
            404,
        ];
        if (((_c = result.error) === null || _c === void 0 ? void 0 : _c.status) &&
            doNotRetryErrorCodes.includes((_d = result.error) === null || _d === void 0 ? void 0 : _d.status)) {
            retry.fail(result.error);
        }
        return result;
    }), {
        maxRetries: (_a = baseConfig.numberOfRetries) !== null && _a !== void 0 ? _a : 3,
    });
};
//# sourceMappingURL=baseQuery.js.map